import {AfterFetchContext, createFetch, OnFetchErrorContext} from "@vueuse/core";
import {API_BASE, API_URLS} from "@/utils/constants/api-urls.ts";
import {IGetResult} from "@/types/api.ts";
import ObjectChecker from "@/utils/ObjectChecker.ts";
import {push} from "notivue";
import axios from "axios";
import router from "@/router";
import CommonUtils from "@/utils/CommonUtils.ts";

export const useFactoryFetch = createFetch({
  baseUrl: API_BASE,
  options: {
    async onFetchError({error, data, response, context, execute}: OnFetchErrorContext) {
      const status = response?.status;
      if (
        status === 401 &&
        !context._retry &&
        !context.url?.includes(API_URLS.auth.refresh)
      ) {
        context._retry = true;
        try {
          await axios.post(API_URLS.auth.refresh, {}, {withCredentials: true});
          return await execute();
        } catch {
          return {error};
        }
      }

      const message = data?.message;
      if (message && status !== 401)
        push.error({title: "Failed", message});

      const redirectUrl = data?.redirectUrl;
      if (router && redirectUrl)
        await router.push(redirectUrl);
      return {error, data};
    },
    async afterFetch(ctx: AfterFetchContext<IGetResult>): Promise<Partial<AfterFetchContext>> | Partial<AfterFetchContext> {
      const message = ctx.data?.message;
      const title = ctx.data?.title;
      const forceLogOut = ctx.data?.data?.forceUserToLogoutOut
      let duration;
      if (forceLogOut)
        duration = 2000;
      if (ObjectChecker.isNotEmptyOrNull(title) || ObjectChecker.isNotEmptyOrNull(message))
        push.warning({
          title,
          message,
          duration,
        })
      if (forceLogOut) {
        if (!duration)
          duration = 2000
        CommonUtils.waitFor(1500).then(() => {
          push.warning({
            message: "سيتم تحويلك لصفحة تسجيل الدخول",
            duration: 1800
          })
        }).then(async () => {
          await CommonUtils.waitFor(2000);
          let href: string;
          if (CommonUtils.isVercelProduction())
            href = "/"
          else
            href = "/auth/login"
          window.location.href = href
        })
      }
      return {data: ctx.data?.data};
    }

  },
  fetchOptions: {
    credentials: "include",
    keepalive: true,
    // method: "GET",
  },
});




